import styled from 'styled-components';

export const CascaderPackageStyled = styled.div`
  .cascader-box {
    .ant-form-item {
      margin-bottom: 10px;
    }
    .ant-cascader-input.ant-input {
      height: ${(props) => props.height} !important;
      border: 0;
      border-radius: 0px;
      background: ${(props) =>
        props.theme[props.brand].formSelect.selectBg} !important;
    }

    .ant-row.ant-form-item {
      position: relative;
      top: 1px;
    }

    .ant-input {
      font-size: ${(props) =>
        props.theme[props.brand].formSelect.fontSize} !important;
    }
    .ant-cascader-picker:focus .ant-cascader-input {
      border-right-width: 0px !important;
      box-shadow: 0 0 0 0px rgba(24, 144, 255, 0.2);
    }
    .ant-cascader-picker:hover .ant-cascader-picker-clear {
      background: ${(props) =>
        props.theme[props.brand].formSelect.selectBg} !important;
    }
  }

  .mt {
    margin-bottom: 0px !important;

    .ant-form-item-explain {
      & > div {
        font-size: 10px;
      }
    }
  }
  .ant-form-item-no-colon {
    text-align: left;
    width: 130px;
    font-size: 16px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    background: ${(props) => props.theme[props.brand].formSelect.singSelectBg};
    display: inline-block;
    height: ${(props) => props.height};
    color: ${(props) => props.theme[props.brand].formSelect.labelColor};
    line-height: ${(props) => props.height};
    padding-left: 13px;
    border: 1px solid
      ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
    border-right: none;
  }
  .ant-form-item-no-colon {
    width: ${(props) => props.labelwidth};
    height: ${(props) => props.height};
    display: flex;
    justify-content: center;
    background: ${(props) => props.theme[props.brand].formSelect.singSelectBg};
    /* color: ${(props) =>
      props.theme[props.brand].formSelect.labelBorColor}; */
    font-size: 16px;
    border-radius: 0px;
    margin-right: 20px;
    border: none !important;
  }
  .label-left .ant-form-item-no-colon {
    justify-content: left;
    align-items: center;
  }

  .mt10 {
    margin-bottom: 10px;
    margin-top: -1px !important;
  }
`;
